/* src/components/LoginScreen.js */
import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import './LoginScreen.css';

function LoginScreen() {
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleGoogleLogin = async () => {
    setLoadingGoogle(true);
    setError(null);
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin
        }
      });
      if (error) throw error;
    } catch (err) {
      setError(err.message);
      setLoadingGoogle(false);
    }
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setLoadingEmail(true);
    setError(null);
    setMessage('');
    try {
      const { error } = await supabase.auth.signInWithOtp({
        email: email,
        options: {
          emailRedirectTo: window.location.origin,
        },
      });
      if (error) throw error;
      setMessage(
  <>
    Check your email for the login link! If this is your first time, it may take a few minutes to arrive (check your spam folder).
    {" "}Please feel free to browse{" "}
    <a
      href="https://walis.app/posts"
      target="_blank"
      rel="noopener noreferrer"
    >
      our blog
    </a>{" "}
    in the meantime to learn more about Wali&apos;s.
  </>
);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingEmail(false);
    }
  };

  return (
    <div className="login-screen-container theme-aware">
      <div className="login-header">
         <img src="/logo.png" alt="Wali's" className="app-icon" />
         <h1>Wali's</h1>
         <div className="login-subtitle">Proven Method for Mastery. Coming soon to iOS.</div>
      </div>

      <div className="login-card">
        <h2>Welcome to Wali's</h2>
        <p style={{marginBottom: '30px', color: 'var(--text-muted)'}}>
            Sign in to access your Daily Docket and retention stats.
        </p>
        
        {error && <div className="error-banner">{error}</div>}
        {message && <div className="confirmation-message">{message}</div>}

        <button 
            className="btn full-width google-btn" 
            onClick={handleGoogleLogin} 
            disabled={loadingGoogle || loadingEmail}
        >
          {loadingGoogle ? 'Redirecting...' : (
              <>
                <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" style={{width: '18px'}} />
                Continue with Google
              </>
          )}
        </button>

        <div className="divider">OR</div>

        <form onSubmit={handleEmailLogin} className="email-form">
            <input
                type="email"
                className="email-input"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loadingGoogle || loadingEmail}
            />
            <button className="btn full-width" type="submit" disabled={loadingGoogle || loadingEmail}>
                {loadingEmail ? 'Sending...' : 'Continue with Email'}
            </button>
        </form>
        
        <div style={{marginTop: '30px', borderTop: '1px solid var(--border-color)', paddingTop: '20px'}}>
            <a href="https://walis.app" className="link-btn small" style={{textDecoration:'none', color: 'var(--text-muted)'}}>
                ← Back to Home Page
            </a>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;